function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "88.281%",
  y1: "100%",
  x2: "11.719%",
  y2: "0%",
  id: "Import_svg__10_c"
}, React.createElement("stop", {
  stopColor: "#7B8B99",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#9BADBC",
  offset: "100%"
})), React.createElement("filter", {
  x: "-.4%",
  y: "-3.6%",
  width: "100.9%",
  height: "109.3%",
  filterUnits: "objectBoundingBox",
  id: "Import_svg__8_a"
}, React.createElement("feMorphology", {
  radius: 1,
  operator: "dilate",
  "in": "SourceAlpha",
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 1,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0",
  "in": "shadowBlurOuter1"
})), React.createElement("rect", {
  id: "Import_svg__9_b",
  x: 0,
  y: 0,
  width: 1004,
  height: 97,
  rx: 6
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-26 -65)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#Import_svg__8_a)",
  xlinkHref: "#Import_svg__9_b"
}), React.createElement("rect", {
  stroke: "#E1E9F0",
  fill: "#FFF",
  x: -0.5,
  y: -0.5,
  width: 1005,
  height: 98,
  rx: 6
})), React.createElement("path", {
  d: "M12 2a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V4a2 2 0 012-2h10zm-6.389 9H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5H5.61a.5.5 0 00.5-.5v-.62a.5.5 0 00-.5-.5zm2.667-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h5.222a.5.5 0 00.5-.5V8.8a.5.5 0 00-.5-.5zm2.666-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h7.888a.5.5 0 00.5-.5V6.1a.5.5 0 00-.5-.5z",
  transform: "translate(0 -2)",
  fill: "url(#Import_svg__10_c)"
}));

var SvgImport = function SvgImport(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16"
  }, props), _ref, _ref2);
};

export default SvgImport;